import { NavLink } from 'react-router-dom';
import { 
  FaHome, FaUsers, FaBell, FaChartPie, FaCode, 
  FaRandom, FaList, FaFlag, FaCube, FaLock, 
  FaCog, FaChartBar, FaDesktop 
} from 'react-icons/fa';

const CDPNavigation = () => {
  const navItems = [
    { path: '/cdp/dashboard', icon: <FaHome />, label: 'Dashboard' },
    { path: '/cdp/profiles', icon: <FaUsers />, label: 'Profiles' },
    { path: '/cdp/events', icon: <FaBell />, label: 'Events' },
    { path: '/cdp/segments', icon: <FaChartPie />, label: 'Segments' },
    { path: '/cdp/rules', icon: <FaCode />, label: 'Rules' },
    { path: '/cdp/campaigns', icon: <FaRandom />, label: 'Campaigns' },
    { path: '/cdp/scoring', icon: <FaList />, label: 'Scoring' },
    { path: '/cdp/goals', icon: <FaFlag />, label: 'Goals' },
    { path: '/cdp/context', icon: <FaCube />, label: 'Context' },
    { path: '/cdp/privacy', icon: <FaLock />, label: 'Privacy' },
    { path: '/cdp/settings', icon: <FaCog />, label: 'Settings' },
    { path: '/cdp/reports', icon: <FaChartBar />, label: 'Reports' },
    { path: '/cdp/monitor', icon: <FaDesktop />, label: 'Monitor' }
  ];

  return (
    <nav className="cdp-navigation">
      {navItems.map(item => (
        <NavLink 
          key={item.path}
          to={item.path}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default CDPNavigation; 